var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('my-company-app-users-by-id',{attrs:{"create-form-url":"/appusers/create"}})
}
var staticRenderFns = []

export { render, staticRenderFns }